export { VpDeletePluginDialog } from './VpDeletePluginDialog';



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpDeletePluginDialog/index.js